import React from 'react';
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';
import { firebaseConnect } from 'react-redux-firebase';

import './Layout.css';
import { ToastContainer, style } from 'react-toastify';

import Header from '../Header/Header';

style({
  width: "320px",
  colorDefault: "#fff",
  colorInfo: "#3498db",
  colorSuccess: "#07bc0c",
  colorWarning: "#f1c40f",
  colorError: "#e74c3c",
  colorProgressDefault: "#000000",
  mobile: "only screen and (max-width : 480px)",
  fontFamily: "Montserrat, sans-serif",
  zIndex: 9999
});

// Basic layout for each page, with some prop toggles
class Layout extends React.Component {
  static propTypes = {
    hasHeader: PropTypes.bool,
    versionDate: PropTypes.string
  };

  render() {
    const { hasHeader, versionCode } = this.props
    return (
      <div>
        {
          hasHeader &&
          <Header ref={node => (this.header = node)} mode={this.props.mode || 'default'} />
        }
        <main className='Layout-main-default'>
          {this.props.children}
        </main>
        <ToastContainer 
          hideProgressBar
          autoClose={3000}
        />
        <span className='Layout-version'>Version: {versionCode}</span>
      </div>
    );
  }
}

const connectedLayout = connect(
  (state) => ({
    versionCode: state.version.code
  })
)(Layout);

const wrappedLayout = firebaseConnect()(connectedLayout);

export default wrappedLayout;


// WEBPACK FOOTER //
// ./src/components/global/Layout/Layout.js